import { MapPin, Clock, AlertTriangle } from "lucide-react";
import { StatusPill } from "./StatusPill";

export const EstablishmentCard = ({ e, onOpen }) => {
  const locationText = e.type === "teleconsultation_domicile"
    ? "À distance · sans déplacement"
    : e.distanceKm != null
      ? `${e.distanceKm} km${e.city ? ` · ${e.city}` : ""}`
      : (e.city || null);
  return (
    <button
      data-testid={`establishment-card-${e.id}`}
      onClick={() => onOpen(e)}
      className="w-full text-left bg-white p-5 rounded-xl border border-slate-200 shadow-sm hover:shadow-md transition-shadow duration-200 active:scale-[0.98] transition-transform"
    >
      <div className="flex items-start justify-between gap-3 mb-2">
        <div>
          <div className="text-[11px] tracking-[0.1em] uppercase font-bold text-[#1E3A8A]">{e.typeLabel}</div>
          <h3 className="font-['Outfit'] font-semibold text-[15px] leading-tight mt-0.5 text-slate-900">{e.name}</h3>
        </div>
        <StatusPill status={e.status} testid={`card-status-${e.id}`} />
      </div>
      <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-sm text-slate-600">
        {locationText && (
          <span className="inline-flex items-center gap-1.5">
            <MapPin className="h-4 w-4 text-slate-400" /> {locationText}
          </span>
        )}
        {e.waitMinutes != null && (
          <span className="inline-flex items-center gap-1.5" data-testid={`card-wait-${e.id}`}>
            <Clock className="h-4 w-4 text-slate-400" /> ~{e.waitMinutes} min d'attente
          </span>
        )}
      </div>
      {e.needsVerification && (
        <span data-testid={`card-unverified-${e.id}`} className="mt-3 inline-flex items-center gap-1.5 text-xs font-semibold text-amber-700 bg-amber-50 border border-amber-200 rounded-full px-2.5 py-1">
          <AlertTriangle className="h-3.5 w-3.5" /> Infos à confirmer
        </span>
      )}
    </button>
  );
};
